import { ApplicationList } from "./ApplicationList";

export default {
  list: ApplicationList,
};
